import { TableColumnSortEnum } from 'CorePackage/MainModule/enums/TableColumnSortEnum';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';
import { KnmListErpIdCell } from 'KnmListPackage/MainModule/components/KnmListRenderErpId';
import { IKnmRaw } from 'KnmListPackage/MainModule/interfaces/IKnmRaw';

export const initialPreventionTableColumns: Array<ITableColumn<IKnmRaw>> = [
  {
    id: 'erpId',
    name: 'Учетный № ПМ',
    sort: TableColumnSortEnum.DESC,
    renderCell: KnmListErpIdCell,
    isSelected: true,
  },
  {
    id: 'kind',
    name: 'Вид ПМ',
    sort: TableColumnSortEnum.NONE,
    isSelected: true,
  },
  {
    id: 'startDateEn',
    name: 'Период проведения',
    sort: TableColumnSortEnum.NONE,
    isSelected: true,
  },
  {
    id: 'controllingOrganization',
    name: 'Орган контроля',
    sort: TableColumnSortEnum.NONE,
    isSelected: true,
  },
  {
    id: 'supervisionType',
    name: 'Вид контроля (надзора)',
    sort: TableColumnSortEnum.NONE,
    isSelected: true,
  },
  {
    id: 'prosecutorOrganization',
    name: 'Орган прокуратуры',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'status',
    name: 'Статус',
    sort: TableColumnSortEnum.NONE,
    isSelected: true,
  },
  {
    id: 'inn',
    name: 'ИНН',
    sort: TableColumnSortEnum.NONE,
    isSelected: true,
  },
  {
    id: 'ogrn',
    name: 'ОГРН',
    sort: TableColumnSortEnum.NONE,
    isSelected: true,
  },
  {
    id: 'snils',
    name: 'СНИЛС',
    sort: TableColumnSortEnum.NONE,
    isSelected: true,
    isHidden: true,
  },
  {
    id: 'rafpNza',
    name: 'НЗА',
    sort: TableColumnSortEnum.NONE,
    isSelected: true,
    isHidden: true,
  },
  {
    id: 'kpp',
    name: 'КПП',
    sort: TableColumnSortEnum.NONE,
    isSelected: true,
    isHidden: true,
  },
  {
    id: 'document',
    name: 'Сведения о документе, удостоверяющем личность',
    sort: TableColumnSortEnum.NONE,
    isSelected: true,
    isHidden: true,
  },
  {
    id: 'organizationName',
    name: 'Контролируемое лицо',
    sort: TableColumnSortEnum.NONE,
    isSelected: true,
  },
  {
    id: 'country',
    name: 'Государство',
    sort: TableColumnSortEnum.NONE,
    isSelected: true,
    isHidden: true,
  },
];
